// extracted by mini-css-extract-plugin
export default {"root":"ContentWithRightAside-module--root--8a099","right":"ContentWithRightAside-module--right--f2ddf"};